import { FileSelectField, FormField } from '@/components/custom/erp';
import type { PhieuChiDetailRow } from '../../types';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface OtherTabProps {
  formMode: FormMode;
  rows: PhieuChiDetailRow[];
}

export const OtherTab: React.FC<OtherTabProps> = ({ formMode, rows }) => {
  const customer = rows[0]?.ma_kh_data;

  return (
    <div className='space-y-2 p-3'>
      <div className='flex flex-col space-y-1'>
        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Mã đối tượng</Label>
          <FormField type='text' name='ma_kh' disabled={true} value={customer?.customer_code} />
          <span className='text-sm'>{customer?.customer_name}</span>
        </div>

        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Kèm theo</Label>
          <FormField type='number' name='so_ct_goc' disabled={formMode === 'view'} />
        </div>

        <div className='flex items-center'>
          <FileSelectField label='Chọn files' formMode={formMode} labelClassName='w-[5.5rem]' />
        </div>

        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Chứng từ gốc</Label>
          <div className='w-full'>
            <FormField type='text' name='dien_giai_ct_goc' disabled={formMode === 'view'} />
          </div>
        </div>
      </div>
    </div>
  );
};
